import {patchState, signalStore, withMethods, withState} from "@ngrx/signals";
import {BatteryVoltage} from "src/app/domain/samples/rssi/battery-voltage";

interface RssiStoreState {
  deviceIdToRssiPerGateway: Map<string, Record<string, number>>;
}

const initialState: RssiStoreState = {
  deviceIdToRssiPerGateway: new Map()
}

export const RssiStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods(store => ({
    setDeviceIdToRssiPerGateway(batteryVoltages: BatteryVoltage[]) {
      const result = new Map();
      batteryVoltages.forEach(batteryVoltage => {
        result.set(batteryVoltage.deviceId, batteryVoltage.rssiPerGateway);
      });
      patchState(store, {deviceIdToRssiPerGateway: result});
    }
  }))
);
